module.exports = __webpack_public_path__ + "img/1122141822.4ef44783.png";